import React from 'react'
import "./About_us_banner.css"
import Breadcrumb_comp from '../../common_component/breadcrumb-comp/Breadcrumb_comp'

function About_us_banner() {
    return (
        <>
            <section className='About_us_banner'>

                <Breadcrumb_comp
                    breadcrumbs={[
                        { label: "Home", link: "/", isActive: false },
                        { label: "About Us", link: "", isActive: true },
                    ]}
                />

                <div className='banner_img_holder'>
                    <img className="banner_img"
                        src={
                            process.env.PUBLIC_URL +
                            "/assets/images/about_us/about_us_banner/banner_img.png"
                        }
                        alt="banner img" />
                </div>
            </section>
        </>
    )
}

export default About_us_banner